import {useSession} from 'next-auth/react'
import {useQuery} from 'react-query'

import {getClientGQL} from '@/utils/clientGql'

export const useTrademarkWatchSubscriptionCount = (trademarkId?: string) => {
  const {data: session} = useSession()
  const userId = session?.user.id

  return useQuery(
    ['trademarkWatchSubscription', userId, trademarkId ?? null],
    async () => {
      try {
        const gqlclient = await getClientGQL()
        const data = (
          await gqlclient.trademarkWatchSubscriptionCount(
            trademarkId ? {filter: {trademark_id: {_eq: trademarkId}}} : undefined,
          )
        )?.trademark_watch_subscription_aggregate?.aggregate?.count

        return data
      } catch (e) {
        throw new Error(e)
      }
    },
    {enabled: Boolean(userId)},
  )
}
